import React, {Component} from 'react';
import {Row, Col, Form, Button} from 'react-bootstrap';
import contactBlockImage from '../assets/contact-block.png';

class ContactBlock extends Component {
  render() {
    return(
      <Row className="le-contact-block">
        <Col md={4} className="address-block">
          <div>
            <p>VISIT US</p>
            <h5>
              3 Plane Hill Rd
              Washington, New Jersey(NJ), 07882
            </h5>
          </div>
          <div>
            <p>CALL US</p>
            <h5>
              +91 9086893656
            </h5>
          </div>
          <div>
            <p>EMAIL US</p>
            <h5>
              support@lineandedges.com
            </h5>
          </div>
        </Col>

        <Col md={3} className="image-block">
          <img src={contactBlockImage} alt="contact-us" />
        </Col>

        <Col md={5} className="form-block">
          <h3>Let's get in Touch</h3>
          <Form.Group>
            <Form.Control type="text" placeholder="Your name" />
            <Form.Control type="email" placeholder="Your email" />
            <Form.Control as="textarea" rows={3} type="text" placeholder="Tell us about your project..."></Form.Control>
          </Form.Group>
          <Button className="le-btn-primary le-btn" size="sm">Submit query</Button>
        </Col>
      </Row>
    )
  }
}

export default ContactBlock;